module.exports = __webpack_public_path__ + "static/media/36_tn.6a17b404.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/36_tn.jpg
// module id = 174
// module chunks = 0